import Vue from 'vue'
import { Cell, CellGroup } from 'vant';
import { Tabbar, TabbarItem } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Grid, GridItem } from 'vant';
import { Slider } from 'vant';
import { Col, Row } from 'vant';
import { NavBar } from 'vant';
import { Overlay } from 'vant';
import { Badge } from 'vant';
import { Picker } from 'vant';
import { Divider } from 'vant';
import { Uploader } from 'vant';
import { Step, Steps } from 'vant';
import { Calendar } from 'vant';

Vue.use(Calendar);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Uploader);
Vue.use(Divider);
Vue.use(Picker);
Vue.use(Badge)
Vue.use(Overlay);
Vue.use(NavBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(Slider);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Cell);
Vue.use(CellGroup);
